module.exports = __webpack_public_path__ + "static/media/4Anniversary.73967c5a.png";